import type { SkuModuleMeta } from '../pipeline-kernel/types';

/** SKU preset / baseline 路径是否有有效预填值（空数组视为无） */
export function hasPresetNestedValue(source: Record<string, unknown>, path: string): boolean {
  const segments = path.split('.');
  let current: unknown = source;
  for (const segment of segments) {
    if (current == null || typeof current !== 'object') return false;
    current = (current as Record<string, unknown>)[segment];
  }
  if (current === undefined || current === null || current === '') return false;
  if (Array.isArray(current)) return current.length > 0;
  return true;
}

/** 解析字段在 preset 中的物理路径（数量 / 选型 / 默认 bare） */
export function resolveFieldPresetPaths(field: string, meta: SkuModuleMeta | undefined): string[] {
  const quantityMapped = meta?.quantityPresetPaths?.[field];
  if (quantityMapped?.length) return quantityMapped;
  const fieldMapped = meta?.fieldPresetPaths?.[field];
  if (fieldMapped?.length) return fieldMapped;
  const bare = field.includes('.') ? field.slice(field.indexOf('.') + 1) : field;
  return bare && bare !== field ? [field, bare] : [field];
}

/** 单个逻辑字段在 baseline 中是否已有预填值（下单字段锁只看自身） */
export function fieldHasPresetValue(field: string, meta: SkuModuleMeta | undefined, baseline: Record<string, unknown>): boolean {
  return resolveFieldPresetPaths(field, meta).some((path) => hasPresetNestedValue(baseline, path));
}

/** 数量字段在 baseline 中是否已有预填值 */
export function quantityFieldHasPresetValue(field: string, meta: SkuModuleMeta | undefined, baseline: Record<string, unknown>): boolean {
  return fieldHasPresetValue(field, meta, baseline);
}

/** 模块是否仍有「无预填、可补填」的数量字段 */
export function moduleHasEditableQuantity(meta: SkuModuleMeta | undefined, baseline: Record<string, unknown>): boolean {
  if (!meta?.quantityFields?.length) return false;
  return meta.quantityFields.some((field) => !quantityFieldHasPresetValue(field, meta, baseline));
}

/**
 * 下单：SKU preset 已有该表单字段值时锁定（如拓扑副本数 replicas / prefillReplicas）。
 * sku-create 不锁。
 */
export function isOrderPresetFieldLocked(
  resourceEditMode: string | undefined,
  preset: Record<string, unknown> | undefined,
  fieldPath: string,
): boolean {
  if (!resourceEditMode || resourceEditMode === 'sku-create') return false;
  if (!preset || !fieldPath) return false;
  return hasPresetNestedValue(preset, fieldPath);
}
